export const LINK_BLUE_COLOR = '#2d6bab';
